import { render } from "./SubclassView.vue?vue&type=template&id=722bd4b7&scoped=true"
import script from "./SubclassView.vue?vue&type=script&lang=js"
export * from "./SubclassView.vue?vue&type=script&lang=js"

import "./SubclassView.vue?vue&type=style&index=0&id=722bd4b7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-722bd4b7"]])

export default __exports__